import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {TuiStatus} from '@taiga-ui/kit';
import {StatusHistory} from '@gatewee/types/system';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-status-history',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
    TuiStatus,
  ],
  templateUrl: './gatewee-status-history.component.html',
  styleUrls: [
    './gatewee-status-history.component.css',
    '../styles/gatewee-collapsible-details.css',
  ],
})
export class GateweeStatusHistoryComponent {
  @Input() statusHistory: StatusHistory[] | null | undefined;
  @Input({required: true}) titleKey!: string;
  @Input({required: true}) emptyKey!: string;
  @Input({required: true}) statusI18nPrefix!: string;
  @Input() statusColorFn?: (status: string) => string;

  constructor(private readonly translate: TranslateService) {}

  get items(): StatusHistory[] {
    return this.statusHistory ?? [];
  }

  displayStatus(status: string): string {
    const key = `${this.statusI18nPrefix}.${status}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : String(status);
  }

  statusTuiColor(status: string): string {
    if (this.statusColorFn) {
      return this.statusColorFn(status);
    }
    return '#526ED3';
  }

  hasMetadata(metadata: Record<string, unknown>): boolean {
    return !!metadata && Object.keys(metadata).length > 0;
  }
}
